<template>
  <div>
    <div
      class="item coll2 comWrapper card mt-2 mb-2 p-3"
      v-for="(item, index) in viewData"
      :key="index"
    >
      <div class="comWrapper-wrapper van-hairline--bottom">
        <span style="background: #f44336"></span>
        {{ item[列[0].field] }}
      </div>
      <van-cell-group>
        <template v-for="(col, idx) in 列">
          <van-cell
            v-if="idx > 0"
            :key="'col_' + idx"
            :title="col.title"
            :value="item[col.field]"
          />
        </template>
        <van-button @click="viewDetail(item)" color="#1989fab7" block>查看详情</van-button>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import {getEnvPunishmentCheckDetail} from '@/apis/company'
import checkMixin from './mixins/check-mixin'
export default {
  name: "envPunishmentCheck",
  mixins: [checkMixin],
  data(){
    return{
      列:[
        {title: "决定书文号", field: "caseNo"},
        {title: "处罚日期", field: "punishDate"},
        {title: "违法类型", field: "illegalType"},
        {title: "处罚单位", field: "punishGov"}
      ],
      页码: 1,
      每页数据量: 10,
      viewData: []
    }
  },
  methods:{
    setApi(cb){
      cb(getEnvPunishmentCheckDetail, 'envPunishmentCheckDetail');
    },
    pagination(){
      this.viewData = this.data;
    }
  },
  created() {
    this.pagination();
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
</style>